import React from 'react';
import { Badge } from '@mantine/core';
import { getShareStatus } from './service/fileShareApi';

const STATUS = {
  active: { label: 'Aktif', color: 'teal' },
  expired: { label: 'Süresi Doldu', color: 'gray' },
  revoked: { label: 'İptal Edildi', color: 'red' },
  limited: { label: 'Limit Doldu', color: 'orange' },
};

export default function TransferStatusBadge({ share, status }) {
  const resolved = STATUS[status || getShareStatus(share)] || STATUS.expired;
  return <Badge color={resolved.color} variant="light" size="sm" radius="sm" tt="none">{resolved.label}</Badge>;
}
